import { createAction, props } from '@ngrx/store';
import { PageItem } from '../domain/page-item';
import { PreviewItem } from './model/preview-item';

const featureKey = 'cxbPageItemPreview';

export const loadPreview = createAction(`${featureKey} Load preview`, props<{ pageItem: PageItem }>());
export const loadPreviewSuccess = createAction(`${featureKey} Load preview success`, props<{ previewItem: PreviewItem }>());
export const loadPreviewFail = createAction(`${featureKey} Load preview fail`, props<{ errorMessage: string }>());
export const setPreviewToInvalid = createAction(`${featureKey} Set preview to invalid`);
export const clearState = createAction(`${featureKey} Clear state`);
